'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdImportantDevices = function MdImportantDevices(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.9 15h5.1l-4.1 3 1.5 4.8-4-3-4.2 3 1.6-4.8-4.2-3h5.1l1.7-5z m13.5-11.6c1.8 0 3.2 1.4 3.2 3.2v8.4h-3.2v-8.4h-30v20h21.6v3.4h-3.4v3.4h3.4v3.2h-13.4v-3.2h3.4v-3.4h-11.6c-1.9 0-3.4-1.6-3.4-3.4v-20c0-1.8 1.5-3.2 3.4-3.2h30z m5 30v-11.8h-8.4v11.8h8.4z m0-15c0.9 0 1.6 0.7 1.6 1.6v15c0 0.9-0.7 1.6-1.6 1.6h-8.4c-0.9 0-1.6-0.7-1.6-1.6v-15c0-0.9 0.7-1.6 1.6-1.6h8.4z' })
        )
    );
};

exports.default = MdImportantDevices;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/important-devices.js
// module id = 1111
// module chunks = 36573943044255 79611799117203 213534597649335